<ng-container>
  <div class='blog-item rounded bg-white shadow-dark wow fadeIn'>
    <div class='details row'>
      <div class='col-lg-9'>
        <h4 class='my-0 title'><a href='javascript:'>
          {{ 'sections.contacts.mentorApply.title' | translate }}!?</a>
        </h4>
        <div class="spacer-20"></div>
        <p>
          {{ 'sections.contacts.mentorApply.paragraph' | translate }}!
        </p>
      </div>
      <div class='col-lg-3 d-flex align-items-center justify-content-end'>
        <kdn-button
          [label]="'buttons.apply' | translate | titlecase"
          (kdmClick)="''"
        >
        </kdn-button>
      </div>
    </div>
  </div>
</ng-container>
